'use client'

import React, { useState, useEffect, useCallback } from 'react'
import { useRouter } from 'next/navigation'

import { RecentSearchList } from './recentSearchList'
import { getflightsHistory, RecentFSearch } from '@/src/utils/storage/recentSearch'
import { formSrpUrl } from '@/src/utils/navigation/formSrpUrl'
import { dataLayerGA } from '@/src/utils/analytics/dataLayerGA'
import { getFormattedDate } from '@/src/utils/date/dateHelper'
import { isEmpty } from '@/src/utils/generalUtils'
import { ONWARD_DIR_ARROW } from '@/src/constants/ui/arrowDirection'

interface RecentSearchListWrapperProps {
    // No props needed as this component manages its own state
}

const RecentSearchListWrapper: React.FC<RecentSearchListWrapperProps> = () => {
    const [flightsSearchList, setFlightsSearchList] = useState<RecentFSearch[]>([])
    const router = useRouter()

    const handleClick = useCallback((searchQuery: RecentFSearch, url: string) => {
        try {
            // Generate the actual URL
            const actualUrl = formSrpUrl(searchQuery)
            
            // Analytics tracking
            const name = `${searchQuery?.sourceCountry} ${isEmpty(searchQuery?.return_date) ? '⇄' : ONWARD_DIR_ARROW} ${
                searchQuery?.destinationCountry
            }`
            
            dataLayerGA(
                { clicked_option_name: name, section: 'Flight' },
                'your_searches_click'
            )

            // Navigate to the search results page
            router.push(actualUrl)
        } catch (error) {
            console.error('Error handling recent search click:', error)
        }
    }, [router])

    useEffect(() => {
        try {
            const recentSearches = getflightsHistory()
            setFlightsSearchList(recentSearches)
        } catch (error) {
            console.error('❌ Error loading recent searches:', error)
            setFlightsSearchList([])
        }
    }, [])

    return (
        <RecentSearchList
            flightsSearchList={flightsSearchList}
            onSearchClick={handleClick}
        />
    )
}

export { RecentSearchListWrapper }
export default RecentSearchListWrapper
